import dayjs from 'dayjs';

export const formatDate = (date, {
  format = 'DD/MM/YYYY',
  readable
} = {}) => {
  if (readable) {
    return dayjs(date).format('MMMM D, YYYY [at] h:mm A');
  }

  return dayjs(date).format(format);
}

export const pluralize = (value, count) => {
  if (count > 1) {
    return value + 's';
  }

  return value;
}

export const urlify = (string) => {
  return string.trim().replace(/\s/g, '%20')
}

export const formatCurrency = (
  value,
  { country = 'AU' } = { country: 'AU' }
) => {
  if (country === 'NZ') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'NZD',
      currencyDisplay: 'code',
    }).format(value);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'AUD',
    currencyDisplay: 'code',
  }).format(value);
};

export const contactNumber = (country = 'AU') => {
  if (country.startsWith('N')) {
    return '0800 663 987';
  }

  return '1300 364 646';
}

export const contactEmail = 'support@absolutedomestics.com.au';
